import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  constructor() {
  }

  cleanFilters(): void {
    this.setFilterPack([]);
    this.setFilterNews([]);
    this.setFilterOffers([]);
    this.setFilterSubItem([]);
    this.setFilterItem([]);
    this.setFilterBrand([]);
    this.setProductDescriptionSearch('');
  }

  cleanOrderFilters(): void {
  }

  cleanReceiptFilters(): void {
    this.setFilterReceiptDescription('');
    this.setFilterReceiptDate('');
    this.setFilterReceiptType([]);
    this.setFilterReceiptState([]);
    this.setFilterOrderReceipt('');
  }

  getCustomerId(): any {
    const valueUser = localStorage.getItem("user");
    if (valueUser) {
      const user = JSON.parse(valueUser);
      if (!(user === null || user === undefined) && !(user.user === null || user.user === undefined) && !(user.user.customer === null || user.user.customer === undefined)) {
        return user.user.customer.id;
      }
    }
    return null;
  }

  getCustomerPercentageDiscount(): any {
    const user = JSON.parse(localStorage.getItem('user') ?? 'null');
    if (!(user === null || user === undefined)) {
      return user.user.customer.lprecio__descuento;
    }
    return null;
  }

  setCustomer(value: any): void {
    const user = JSON.parse(localStorage.getItem('user') ?? 'null');
    user.user.customer = value;
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  setCarBrands(value: any): void {
    sessionStorage.setItem('car-brands', JSON.stringify(value));
  }

  getCarBrands(): any {
    return JSON.parse(sessionStorage.getItem('car-brands') ?? 'null');
  }

  setCarModels(value: any): void {
    sessionStorage.setItem('car-models', JSON.stringify(value));
  }

  getCarModels(): any {
    return JSON.parse(sessionStorage.getItem('car-models') ?? 'null');
  }

  setBrands(value: any): void {
    sessionStorage.setItem('brands', JSON.stringify(value));
  }

  getBrands(): any {
    return JSON.parse(sessionStorage.getItem('brands') ?? 'null');
  }

  setBrandsHeader(value: any): void {
    sessionStorage.setItem('brands-header', JSON.stringify(value));
  }

  getBrandsHeader(): any {
    return JSON.parse(sessionStorage.getItem('brands-header') ?? 'null');
  }

  setBrandsHome(value: any): void {
    sessionStorage.setItem('brands-home', JSON.stringify(value));
  }

  getBrandsHome(): any {
    return JSON.parse(sessionStorage.getItem('brands-home') ?? 'null');
  }

  setBrandsConfiguration(value: any): void {
    sessionStorage.setItem('brands-configuration', JSON.stringify(value));
  }

  getBrandsConfiguration(): any {
    return JSON.parse(sessionStorage.getItem('brands-configuration') ?? 'null');
  }

  setBrandsOffers(value: any): void {
    sessionStorage.setItem('brands-offers', JSON.stringify(value));
  }

  getBrandsOffers(): any {
    return JSON.parse(sessionStorage.getItem('brands-offers') ?? 'null');
  }

  setItem(value: any): void {
    sessionStorage.setItem('items', JSON.stringify(value));
  }

  getItem(): any {
    return JSON.parse(sessionStorage.getItem('items') ?? 'null');
  }

  setItemHeader(value: any): void {
    sessionStorage.setItem('items-header', JSON.stringify(value));
  }

  getItemHeader(): any {
    return JSON.parse(sessionStorage.getItem('items-header') ?? 'null');
  }

  setSubItem(value: any): void {
    sessionStorage.setItem('subItems', JSON.stringify(value));
  }

  getSubItem(): any {
    return JSON.parse(sessionStorage.getItem('subItems') ?? 'null');
  }

  setSubItemOffers(value: any): void {
    sessionStorage.setItem('subItems-offers', JSON.stringify(value));
  }

  setItemOffers(value: any): void {
    sessionStorage.setItem('item-offers', JSON.stringify(value));
  }

  getSubItemOffers(): any {
    return JSON.parse(sessionStorage.getItem('subItems-offers') ?? 'null');
  }

  getItemOffers(): any {
    return JSON.parse(sessionStorage.getItem('item-offers') ?? 'null');
  }

  setProducts(value: any): void {
    sessionStorage.setItem('products', JSON.stringify(value));
  }

  getProducts(): any {
    return JSON.parse(sessionStorage.getItem('products') ?? 'null');
  }

  setOffers(value: any): void {
    sessionStorage.setItem('offers', JSON.stringify(value));
  }

  getOffers(): any {
    return JSON.parse(sessionStorage.getItem('offers') ?? 'null');
  }

  setStockIntervals(value: any): void {
    sessionStorage.setItem('intervals', JSON.stringify(value));
  }

  getStockIntervals(): any {
    return JSON.parse(sessionStorage.getItem('intervals') ?? 'null');
  }

  setStockColorIntervals(value: any): void {
    sessionStorage.setItem('intervals-colors', JSON.stringify(value));
  }

  getStockColorIntervals(): any {
    return JSON.parse(sessionStorage.getItem('intervals-colors') ?? 'null');
  }

  setProductDescriptionSearch(value: string): void {
    sessionStorage.setItem('description-search', value);
  }

  getProductDescriptionSearch(): string {
    return sessionStorage.getItem('description-search') ?? '';
  }

  setCurrentPage(value: string): void {
    sessionStorage.setItem('current-page', value);
  }

  getCurrentPage(): string {
    return sessionStorage.getItem('current-page') ?? '';
  }

  setFilterCarBrand(value: any): void {
    sessionStorage.setItem('filter-car-brand', JSON.stringify(value));
  }

  getFilterCarBrand(): any {
    return JSON.parse(sessionStorage.getItem('filter-car-brand') ?? 'null');
  }

  setFilterCarModel(value: any): void {
    sessionStorage.setItem('filter-car-model', JSON.stringify(value));
  }

  getFilterCarModel(): any {
    return JSON.parse(sessionStorage.getItem('filter-car-model') ?? 'null');
  }

  setFilterBrand(value: any): void {
    sessionStorage.setItem('filter-brand', JSON.stringify(value));
  }

  getFilterBrand(): any {
    return JSON.parse(sessionStorage.getItem('filter-brand') ?? 'null');
  }

  setFilterSubItem(value: any): void {
    sessionStorage.setItem('filter-sub-item', JSON.stringify(value));
  }

  getFilterSubItem(): any {
    return JSON.parse(sessionStorage.getItem('filter-sub-item') ?? 'null');
  }

  setFilterPromotions(value: any): void {
    sessionStorage.setItem('filter-promotions', JSON.stringify(value));
  }

  getFilterPromotions(): any {
    return JSON.parse(sessionStorage.getItem('filter-promotions') ?? 'null');
  }

  setPromotions(value: any): void {
    sessionStorage.setItem('promotions', JSON.stringify(value));
  }

  getPromotions(): any {
    return JSON.parse(sessionStorage.getItem('promotions') ?? 'null');
  }

  setFilterItem(value: any): void {
    sessionStorage.setItem('filter-item', JSON.stringify(value));
  }

  getFilterItem(): any {
    return JSON.parse(sessionStorage.getItem('filter-item') ?? 'null');
  }

  setFilterOrder(value: string): void {
    sessionStorage.setItem('filter-order', value);
  }

  getFilterOrder(): string | null {
    if (sessionStorage.getItem('filter-order') === '') {
      return null;
    }

    return sessionStorage.getItem('filter-order');
  }

  setFilterOrderReceipt(value: string): void {
    sessionStorage.setItem('filter-order-receipt', value);
  }

  getFilterOrderReceipt(): string | null {
    if (sessionStorage.getItem('filter-order-receipt') === '') {
      return null;
    }

    return sessionStorage.getItem('filter-order');
  }

  setOffersCount(value: string): void {
    sessionStorage.setItem('offer-count', value);
  }

  getOffersCount(): any {
    return sessionStorage.getItem('offer-count');
  }

  setFilterOffers(value: any): void {
    sessionStorage.setItem('filter-offers', JSON.stringify(value));
  }

  getFilterOffers(): any {
    return JSON.parse(sessionStorage.getItem('filter-offers') ?? 'null');
  }

  setFilterNews(value: any): void {
    sessionStorage.setItem('filter-news', JSON.stringify(value));
  }

  getFilterNews(): any {
    return JSON.parse(sessionStorage.getItem('filter-news') ?? 'null');
  }

  setFilterPack(value: any): void {
    sessionStorage.setItem('filter-pack', JSON.stringify(value));
  }

  getFilterPacks(): any {
    return JSON.parse(sessionStorage.getItem('filter-pack') ?? 'null');
  }

  setHomePacks(value: any): void {
    sessionStorage.setItem('home-pack', JSON.stringify(value));
  }

  getHomePacks(): any {
    return JSON.parse(sessionStorage.getItem('home-pack') ?? 'null');
  }

  setHomeNews(value: any): void {
    sessionStorage.setItem('home-news', JSON.stringify(value));
  }

  getHomeNews(): any {
    return JSON.parse(sessionStorage.getItem('home-news') ?? 'null');
  }

  setConfigurationMarkup(value: any): void {
    sessionStorage.setItem('configuration-markup', JSON.stringify(value));
  }

  getConfigurationMarkup(): any {
    return JSON.parse(sessionStorage.getItem('configuration-markup') ?? 'null');
  }

  setEnableMarkup(value: any): void {
    sessionStorage.setItem('enable-markup', JSON.stringify(value));
  }

  getEnableMarkup(): any {
    return JSON.parse(sessionStorage.getItem('enable-markup') ?? 'null');
  }

  setEnableShowIva(value: any): void {
    sessionStorage.setItem('enable-iva', JSON.stringify(value));
  }

  getEnableShowIva(): any {
    return JSON.parse(sessionStorage.getItem('enable-iva') ?? 'null');
  }

  addItemShoppingCar(item: any): void {
    let items: any[] = this.getShoppingCar();
    if (!(items === null || items === undefined)) {
      items.push(item);

    } else {
      items = [item];
    }

    localStorage.setItem('shopping-car', JSON.stringify(items));
  }

  setShoppingCar(items: any): void {
    localStorage.setItem('shopping-car', JSON.stringify(items));
  }

  getShoppingCar(): any {
    if (localStorage.getItem("shopping-car")) {
      return JSON.parse(localStorage.getItem('shopping-car') ?? 'null');
    }
    return null;
  }

  clearShoppingCar(): void {
    localStorage.removeItem('shopping-car');
  }

  setShipping(value: any): void {
    sessionStorage.setItem('shipping', JSON.stringify(value));
  }

  getShipping(): any {
    return JSON.parse(sessionStorage.getItem('shipping') ?? 'null');
  }

  setAppointment(value: any): void {
    sessionStorage.setItem('appointment', JSON.stringify(value));
  }

  getAppointment(): any {
    return JSON.parse(sessionStorage.getItem('appointment') ?? 'null');
  }

  setReceiptState(value: any): void {
    sessionStorage.setItem('receipt-state', JSON.stringify(value));
  }

  getReceiptState(): any {
    return JSON.parse(sessionStorage.getItem('receipt-state') ?? 'null');
  }

  setOrderState(value: any): void {
    sessionStorage.setItem('order-state', JSON.stringify(value));
  }

  getOrderState(): any {
    return JSON.parse(sessionStorage.getItem('order-state') ?? 'null');
  }

  setTypeOfShipping(value: any): void {
    sessionStorage.setItem('type-of-shipping', JSON.stringify(value));
  }

  getTypeOfShipping(): any {
    return JSON.parse(sessionStorage.getItem('type-of-shipping') ?? 'null');
  }

  setDeliverysMode(value: any): void {
    sessionStorage.setItem('delivery-mode', JSON.stringify(value));
  }

  getDeliverysMode(): any {
    return JSON.parse(sessionStorage.getItem('delivery-mode') ?? 'null');
  }

  setFilterReceiptState(value: any) {
    sessionStorage.setItem('filter-receipt-state', JSON.stringify(value));
  }

  getFilterReceiptState(): any {
    return JSON.parse(sessionStorage.getItem('filter-receipt-state') ?? 'null');
  }

  setFilterOrderState(value: any) {
    sessionStorage.setItem('filter-order-state', JSON.stringify(value));
  }

  getFilterOrderState(): any {
    return JSON.parse(sessionStorage.getItem('filter-order-state') ?? 'null');
  }

  setFilterTypeOfShipping(value: any): void {
    sessionStorage.setItem('filter-type-of-shipping', JSON.stringify(value));
  }

  getFilterTypeOfShipping(): any {
    return JSON.parse(sessionStorage.getItem('filter-type-of-shipping') ?? 'null');
  }

  setFilterReceiptType(value: any): void {
    sessionStorage.setItem('filter-receipt-type', JSON.stringify(value));
  }

  getFilterReceiptType(): any {
    return JSON.parse(sessionStorage.getItem('filter-receipt-type') ?? 'null');
  }

  setReceiptType(value: any): void {
    sessionStorage.setItem('receipt-type', JSON.stringify(value));
  }

  getReceiptType(): any {
    return JSON.parse(sessionStorage.getItem('receipt-type') ?? 'null');
  }

  setFilterReceiptDate(value: any): void {
    sessionStorage.setItem('filter-receipt-date', JSON.stringify(value));
  }

  getFilterReceiptDate(): any {
    return JSON.parse(sessionStorage.getItem('filter-receipt-date') ?? 'null');
  }

  setFilterReceiptDescription(value: any): void {
    sessionStorage.setItem('filter-receipt-description', JSON.stringify(value));
  }

  getFilterReceiptDescription(): any {
    return JSON.parse(sessionStorage.getItem('filter-receipt-description') ?? 'null');
  }

  setAmountAccounting(value: string): void {
    sessionStorage.setItem('amount', value);
  }

  getAmountAccounting(): string {
    return sessionStorage.getItem('amount') ?? '';
  }

  getTypeOfCustomer(): any {
    const user = localStorage.getItem("user");
    if (user) {
      const userObj = JSON.parse(user);
      if (userObj && userObj.user && userObj.user.customer) {
        return userObj.user.customer.cliva__idtipcli;
      }
    }
    return 1;
  }

  isFinalCustomer(): boolean  {
    if (Number(this.getTypeOfCustomer()) === 1) {
      return true;
    }
    return false;
  }

  isLogin(): boolean {
    const token: any = localStorage.getItem('user');
    if (!(token === null || token === undefined)) {
      const value = JSON.parse(token);
      if (value.user && value.user.customer) {
        return true;
      }
    }

    return false;
  }

  setProvince(provinces: any): void {
    localStorage.setItem("provinces", JSON.stringify(provinces));
  }

  getProvince(): any {
    return JSON.parse(localStorage.getItem("provinces") ?? 'null');
  }

  setTabSelected(tab: string): void {
    localStorage.setItem("tab-selected", tab);
  }

  getTabSelected(): any {
    return localStorage.getItem("tab-selected");
  }

  setPriceList(values: any): void {
    localStorage.setItem("price-list", JSON.stringify(values));
  }

  getPriceList(): any {
    return JSON.parse(localStorage.getItem("price-list") ?? 'null');
  }

  getSessionId(): string {
    let currentSession = localStorage.getItem("session-id");
    if (currentSession) {
      return currentSession;
    }

    const newSession: string = (crypto as any).randomUUID();
    localStorage.setItem("session-id", newSession);
    return newSession;
  }
}
